import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryPropertyNotHaveBricks extends AnnualSummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('The number of bricks is more than the available', options);
        this.propertyId = propertyId;
    }
}
export default AnnualSummaryPropertyNotHaveBricks;
